import { useHistory, useLocation } from '@react-router';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { withWindow } from '@shared/utils/withWindow';
import { useEffect, useRef } from 'react';
import { CATALOG_PRODUCT_LIST_PAGE_SIZE } from '../../Catalog.constants';

export const useInitialPageSizeFromLocationState = (pageSize: number, showValuePropCards: boolean) => {
  const location = useLocation<{
    catalogPageByUrl: {
      url: string;
      page: number;
    };
  }>();
  const pageRef = useRef(location.state?.catalogPageByUrl?.url === location.pathname ? location.state?.catalogPageByUrl?.page : 1);

  const url = location.state?.catalogPageByUrl?.url;

  let initialPageSize = pageSize;
  if (url === location.pathname) {
    initialPageSize = pageRef.current * CATALOG_PRODUCT_LIST_PAGE_SIZE - (showValuePropCards ? (pageRef.current === 1 ? 2 : 4) : 0);
  }

  return initialPageSize;
};

export const clearLocationState = () => {
  withWindow(global => {
    global.history.replaceState({}, global.document.title);
  });
};

export const useResetLocationStateUponPageReload = () => {
  useEffect(() => {
    withWindow(global => {
      // Reset location state upon page refresh, only want to preload when using in-app navigation
      global.addEventListener('beforeunload', () => {
        global.history.replaceState(null, global.document.title);
      });
    });
  }, []);
};

export const useTrackCatalogPageByUrl = () => {
  const history = useHistory();

  return useEventCallback((path: string, page: number) => {
    history.replace(path, { catalogPageByUrl: { url: path, page } });
  });
};
